import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/54350176/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const ComponentDocs = makeShortcode("ComponentDocs");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Inline notification`}</h2>
    <ComponentCode name="Inline notification" component="notification" variation="inline-notification" hasReactVersion="notifications--inline" hasVueVersion="inlinenotification--default" hasAngularVersion="?path=/story/notification--basic" codepen="NmNrLg" mdxType="ComponentCode"></ComponentCode>
    <h2>{`Toast notification`}</h2>
    <ComponentCode name="Toast notification" component="notification" variation="toast-notification" hasReactVersion="notifications--toast" hasVueVersion="toastnotification--default" hasAngularVersion="?path=/story/notification--toast" codepen="vMGKQO" mdxType="ComponentCode"></ComponentCode>
    <h2>{`Documentation`}</h2>
    <ComponentDocs component="notification" mdxType="ComponentDocs"></ComponentDocs>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      